import { useSyncExternalStore } from "react";

import { sipClient } from "./sipClient";

// Store compartilhado do softphone.
//
// Fonte unica do estado do ramal (registro, chamada, mudo, etc.) e das acoes
// (ligar, atender, encerrar). O widget flutuante e os botoes no cabecalho do
// ticket leem/escrevem aqui, entao os dois falam com o mesmo ramal.

let state = {
	conta: null,
	regState: "unregistered",
	callState: "idle",
	incoming: null,
	muted: false,
	aberto: false,
	numero: "",
};

const subs = new Set();
const emit = () => {
	state = { ...state };
	subs.forEach((fn) => fn());
};
const set = (patch) => {
	Object.assign(state, patch);
	emit();
};

let audioEl = null;
export const setAudioEl = (el) => {
	audioEl = el;
};

let ligado = false;
const ligarCallbacks = () => {
	if (ligado) return;
	ligado = true;
	sipClient.onRegStateChange = (regState) => set({ regState });
	sipClient.onCallStateChange = (callState) => set({ callState });
	sipClient.onIncomingCall = (incoming) => set({ incoming, aberto: true });
	sipClient.onCallEnded = () => set({ incoming: null, callState: "idle" });
	sipClient.onMuteChange = (muted) => set({ muted });
	sipClient.onRemoteStream = (stream) => {
		if (audioEl) {
			audioEl.srcObject = stream;
			if (stream) audioEl.play().catch(() => {});
		}
	};
};

// Configura a conta SIP e registra. Chamado uma vez pelo widget, depois que
// ele carrega a config da empresa + o ramal do usuario.
export const configurar = (conta) => {
	ligarCallbacks();
	set({ conta });
	if (conta) {
		try {
			sipClient.connect(conta);
		} catch {
			/* noop */
		}
	}
};

export const desconfigurar = () => {
	try {
		sipClient.disconnect();
	} catch {
		/* noop */
	}
	set({ conta: null, regState: "unregistered", callState: "idle" });
};

export const abrir = () => set({ aberto: true });
export const fechar = () => set({ aberto: false });
export const setNumero = (numero) => set({ numero });

export const ligarPara = (numero) => {
	if (!state.conta || !numero) return;
	set({ aberto: true, numero });
	sipClient.call(numero, state.conta.domain);
};

export const atender = () => sipClient.answer();
export const rejeitar = () => sipClient.reject();
export const encerrar = () => sipClient.hangup();
export const mutar = () => sipClient.toggleMute();
export const digitar = (d) => {
	if (state.callState !== "idle") sipClient.sendDtmf(d);
	else set({ numero: state.numero + String(d) });
};
export const apagar = () => set({ numero: state.numero.slice(0, -1) });

const subscribe = (fn) => {
	subs.add(fn);
	return () => subs.delete(fn);
};
const getSnapshot = () => state;

export const useSoftphone = () => useSyncExternalStore(subscribe, getSnapshot);
